import type { RecipeRepository } from "../ports/repositories";

export async function deleteRecipe(
  dependencies: { readonly recipes: RecipeRepository },
  recipeId: string,
): Promise<void> {
  const recipe = await dependencies.recipes.getById(recipeId);
  if (!recipe) throw new Error("Recipe not found");
  await dependencies.recipes.delete(recipeId);
}
